import styled from 'styled-components';
import { css } from '@styled-system/css';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, themeMode, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var PopoverSizes = variant({
  prop: "size",
  variants: {
    auto: {
      width: "auto",
      minWidth: "260px"
    },
    xs: {
      width: "160px"
    },
    sm: {
      width: "240px"
    },
    md: {
      width: "360px"
    },
    lg: {
      width: "480px"
    }
  }
});
var Container = styled(Box).withConfig({
  componentId: "sc-18pski6-0"
})(function (props) {
  return css({
    backgroundColor: color("surface")(props),
    color: themeMode({
      light: "neutral.900",
      dark: "neutral.0"
    })(props),
    boxShadow: 3,
    borderRadius: "base",
    overflow: "hidden",
    margin: "0 auto",
    maxWidth: "100%",
    py: "xs",
    px: "sm"
  });
}, PopoverSizes);
export { Container };